import { render, staticRenderFns } from "./CampaignInsights.vue?vue&type=template&id=ae439ae6&scoped=true&"
import script from "./CampaignInsights.vue?vue&type=script&lang=js&"
export * from "./CampaignInsights.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInsights.vue?vue&type=style&index=0&id=ae439ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae439ae6",
  null
  
)

export default component.exports